"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jotai_1 = require("jotai");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var devtools_1 = require("react-query/devtools");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var data_layer_1 = require("../checkout/helpers/data_layer");
var button_1 = __importDefault(require("./button"));
var product_sheet_1 = __importDefault(require("./product-sheet"));
var state_1 = require("./state");
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
/**
 * @todo Maybe create a reusable App component in a new file and define these GA reporters there so that they can be re-used if we ever render this component through React
 */
var buildEventData = function (product, variant) {
    var _a;
    var _b = (0, data_layer_1.buildProductVariantTitle)(product.title, variant.title), key = _b.key, value = _b.value;
    // we get this in cents, so have to convert it to dollars for GA
    var price = Number(variant.price) / 100;
    if (isNaN(price))
        throw new Error('Invalid price');
    return _a = {}, _a[key] = value, _a.product_title = product.title, _a.variant_title = variant.title, _a.variant_price = price, _a;
};
var onQuickAddButtonClick = function (product, variant) {
    var _a;
    // We decided to just match this event's data to that of collectionsQuickAdd__productAddedToCart even though this click doesn't really represent a particular variant, but rather the product as a whole.
    // It's probably most accurate to interpret this event in GTM/GA based on only the product, not the variant, since the variant is just arbitrarily the first variant in the product's variant list.
    var eventData = buildEventData(product, variant);
    var data = __assign({ event: 'collectionsQuickAdd__buttonClicked' }, eventData);
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(data);
};
var onDoneAddingToCart = function (product, variant) {
    var _a;
    var eventData = buildEventData(product, variant);
    var data = __assign({ event: 'collectionsQuickAdd__productAddedToCart' }, eventData);
    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(data);
};
var Index = function (_a) {
    var product = _a.product, productUrl = _a.productUrl, buttonText = _a.buttonText, className = _a.className, mainImageCover = _a.mainImageCover, bottomImageUrl = _a.bottomImageUrl, hideLearnMoreLink = _a.hideLearnMoreLink;
    var _b = __read((0, react_1.useState)(false), 2), yipeeIWasFirstAndGetToRenderTheProductSheet = _b[0], setYipeeIWasFirstAndGetToRenderTheProductSheet = _b[1];
    var _c = __read((0, jotai_1.useAtom)(state_1.productSheetRenderedAtom), 2), productSheetRendered = _c[0], setProductSheetRendered = _c[1];
    // Because of some messy state management we're doing, we only have to render one product sheet and it will be used by all of the quick add apps.
    // Here, we are cognizant of the fact that other quick add apps may exist on the page and we only render a single product sheet to be re-used by all of them.
    if (!productSheetRendered && !yipeeIWasFirstAndGetToRenderTheProductSheet) {
        setYipeeIWasFirstAndGetToRenderTheProductSheet(true);
        setProductSheetRendered(true);
    }
    return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
        react_1.default.createElement(devtools_1.ReactQueryDevtools, { initialIsOpen: false }),
        react_1.default.createElement(button_1.default, { product: product, productUrl: productUrl, buttonText: buttonText, className: className, mainImageCover: mainImageCover, bottomImageUrl: bottomImageUrl, onClick: onQuickAddButtonClick }),
        yipeeIWasFirstAndGetToRenderTheProductSheet && react_1.default.createElement(product_sheet_1.default, { onDoneAddingToCart: onDoneAddingToCart, hideLearnMoreLink: hideLearnMoreLink })));
};
(0, render_app_1.default)('data-quick-add-app', function (el) {
    var datasetProduct = el.dataset.product;
    if (!datasetProduct)
        throw new Error('Missing quick-add data-product');
    var product = JSON.parse(datasetProduct);
    var productUrl = el.dataset.productUrl;
    var buttonText = el.dataset.buttonText;
    var className = el.dataset.className;
    var mainImageCover = el.dataset.mainImageCover === 'true' ? true : false;
    var bottomImageUrl = el.dataset.bottomImageUrl;
    var hideLearnMoreLink = el.dataset.hideLearnMoreLink === 'true' ? true : false;
    // this is necessary not for the variant selector app, but for the add to cart app, which accesses this object
    window.variantSelectorApp = {
        product: product,
        hideAddToCartButton: false,
        hideBundleButtonDesktop: false,
        hideBundleButtonMobile: false,
        bundleAndSaveButtonLink: '',
        bundleAndSaveButtonText: '',
        nonShoppableSiteSettings: {
            enabled: false,
        },
        modalSettings: {
            enableModal: false,
        },
        exclamationTriangleIconURL: window.quickAddApp.exclamationTriangleIconURL,
    };
    return (react_1.default.createElement(Index, { product: product, productUrl: productUrl, buttonText: buttonText, className: className, mainImageCover: mainImageCover, bottomImageUrl: bottomImageUrl, hideLearnMoreLink: hideLearnMoreLink }));
});
